import styled from 'styled-components';

import {
  Button as ButtonLayoutComponent, ErrorHandler, CenteredLoader, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: block;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
`;

export const Button = styled(ButtonLayoutComponent)``;

export const Text = styled(TextLayoutComponent)``;

export const Error = styled(ErrorHandler)``;

export const Loader = styled(CenteredLoader)``;
